import FileDropzone from './file-dropzone';
import './file-dropzone.scss';

export default FileDropzone;
